import React, { useState } from "react";
import { Link } from "react-router-dom";
import { IAnalysisFolder } from "./IAnalysisFolder";
import { getFolderIconByIndex } from "../../../../utils/folderIcons";
import "./FullAnalysisFile.css";

const SHOW_MORE_THRESHOLD = 200;

const FullAnalysisHead = ({data}: {data: {
    name: string,
    tags: Array<string>,
    avatarUrl?: string,
    link?: string,
    linkText?: string,
    date: string,
    action: string
}})=>{
    return <div className="FullAnalysisFileRecord_head">
        <div className="FullAnalysisFileRecord_head_avatar" style={{backgroundImage:`url(${data.avatarUrl})`}}>

        </div>
        <div className="FullAnalysisFileRecord_head_right">
            <div className="FullAnalysisFileRecord_head_right_top">
                <div className="FullAnalysisFileRecord_head_name">
                    {data.name}
                </div>
                <div className="FullAnalysisFileRecord_head_tags">
                    {data.tags.map(tag=><div className="FullAnalysisFileRecord_head_tag">{tag}</div>)}
                </div>
                <div className="FullAnalysisFileRecord_head_date">
                    {data.date}
                </div>
            </div>
            <div className="FullAnalysisFileRecord_head_action">
                {data.action} {data.link
                    ? <Link to={data.link}>{data.linkText}</Link>
                    : <span>{data.linkText}</span>
                }
            </div>
        </div>
    </div>
}

const FullAnalysisPhotos = ({photos}: {photos: Array<string>})=>{
    return <div className="FullAnalysisFileRecord_photos">
        {photos.map((photo)=>{
            return <div className="FullAnalysisFileRecord_photo_wrap">
                <img className="FullAnalysisFileRecord_photo_img" src={photo} />
            </div>
        })}
    </div>
}

const FullAnalysisUpdatedNotes = ({data}: {data: {
    iconUrl: string,
    title: string,
    date: string
}})=>{
    return <div className="FullAnalysisUpdatedNotes">
        <div className="FullAnalysisUpdatedNotes_icon" style={{backgroundImage: `url(${data.iconUrl})`}}>

        </div>

        <div className="FullAnalysisUpdatedNotes_right">
            <div className="FullAnalysisUpdatedNotes_title">
                {data.title}
            </div>
            <div className="FullAnalysisUpdatedNotes_date">
                {data.date}
            </div>
        </div>
    </div>
}

const FullAnalysisQuote = ({data}: {data: {
    title: string,
    text: string,
}})=>{
    const [expanded, setExpanded] = useState(false);
    const isLong = data.text?.length > SHOW_MORE_THRESHOLD;

    return (
        <div className="FullAnalysisFileRecord_content_quote">
            <div className={`FullAnalysisFileRecord_content_quote_text${!expanded && isLong ? ' FullAnalysisFileRecord_content_quote_text--collapsed' : ''}`}>
                <span className="FullAnalysisFileRecord_content_title">
                    {data.title}
                </span>
                <span className="FullAnalysisFileRecord_content_text">
                    {data.text}
                </span>
            </div>
            {isLong && (
                <div
                    className="FullAnalysisFileRecord_content_showMore"
                    onClick={() => setExpanded(e => !e)}
                >
                    {expanded ? 'Show less' : 'Show more...'}
                </div>
            )}
        </div>
    )
}

export const FullAnalysisFile = ({className, file}: {className?: string, file:IAnalysisFolder})=>{
    if (file.type != 'file' || !file.fileData){
        return;
    }

    return <div className={`FullAnalysisFile ${className ? className : ''}`}>
        {file.fileData.map(data=>{
            return  <div className="FullAnalysisFileRecord">
                <FullAnalysisHead data={data}
                ></FullAnalysisHead>
                <div className="FullAnalysisFileRecord_content">
                    {data.chunks.map(chunk=>{
                        if (chunk.type == 'notes'){
                            return <FullAnalysisUpdatedNotes data={chunk.data}></FullAnalysisUpdatedNotes>
                        } else
                        if (chunk.type == 'quote'){
                            return <FullAnalysisQuote data={chunk.data}></FullAnalysisQuote>
                        } else
                        if (chunk.type == 'photos'){
                            return <FullAnalysisPhotos photos={chunk.data.photos}></FullAnalysisPhotos>
                        }
                        return ''
                    })}
                </div>
            </div>
        })}
    </div>
}